import { useSubscriptionContext } from '~/providers/SubscriptionProvider';
import { getFixedPlanIncludedStorageBytes } from '~/utils/getFixedPlanIncludedStorageBytes';

export const useShouldShowStorageUsage = () => {
  const { data: subscription } = useSubscriptionContext();

  const includedBytes = getFixedPlanIncludedStorageBytes(subscription);
  const maxStorageBytes = subscription?.maxStorage ?? includedBytes;

  return {
    maxStorageBytes,
    shouldShowStorageUsage: !!maxStorageBytes,
  };
};
